<template>
  <v-row no-gutters>
    <v-col cols="5" xl="5" lg="6" md="12">
      <InputsTree :inputs="inputsData" :data="data" />
    </v-col>
    <v-col cols="7" xl="7" lg="6" md="12">
      <h4>{{ $t("strings.key-value-module") }}</h4>
      <h6>{{ $t("strings.key-value-tip") }}</h6>
      <v-sheet
        class="overflow-y-auto pt-4"
        :max-height="data.parentContentHeight"
      >
        <v-form ref="form" class="pa-2">
          <KeyValueBlock :data="data" />
        </v-form>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { inject, provide, reactive, toRefs, watch, computed } from "vue";
import InputsTree from "../blocks/static/InputsListTree.vue";
import KeyValueBlock from "../blocks/static/KeyValueBlock.vue";

export default {
  name: "OperatorCreateObject",
  props: ["target", "data", "operatorInputs"],
  emits: ["updateFormData"],
  components: {
    InputsTree,
    KeyValueBlock,
  },
  setup(props, { emit }) {
    const valid = inject("valid");
    valid.value = true; //no validation used
    //Creates a deep copy, unlinked of target.userData
    const formData = reactive(
      JSON.parse(JSON.stringify(props.target.userData)) || {},
    );
    provide("formData", formData);
    watch(
      formData,
      (newFormData) => {
        emit("updateFormData", newFormData);
      },
      { deep: true, immediate: true },
    );

    let inputsData = computed(() => {
      return props.operatorInputs;
    });

    return { valid, inputsData, formData, ...toRefs(formData) };
  },
};
</script>
